import axios from 'axios';

// 计算默认后端地址：优先读取环境变量，否则回退到当前主机的8000端口// 动态获取API基础URL - 完全依赖环境变量或当前域名
const API_BASE_URL = (() => {
  // 优先使用环境变量
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // 开发环境使用相对路径（通过Vite代理）
  if (import.meta.env.DEV) {
    return '/api';
  }

  // 生产环境使用当前域名+端口
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:8000`;
  }

  // SSR环境fallback
  return '/api';
})();

// 创建axios实例
const api = axios.create({
  // 开发环境默认走主API网关（8000端口）
  baseURL: process.env.NODE_ENV === 'production' ? '' : API_BASE_URL,
  timeout: 1200000, // 20分钟超时时间（1200秒）
  headers: {
    'Content-Type': 'application/json',
  },
});

// P2-7 修复：只在开发环境输出调试日志
api.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    if (import.meta.env.DEV) {
      console.log('发送请求:', config.method, config.url);
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    // P2-7 修复：只在开发环境输出调试日志
    if (import.meta.env.DEV) {
      console.log('API响应拦截器:', response);
    }
    
    // 直接返回响应数据，不再嵌套data
    if (response.data !== undefined) {
      return response.data;
    }
    return response;
  },
  (error) => {
    // 对响应错误做点什么
    // P2-7 修复：只在开发环境输出调试日志
    if (import.meta.env.DEV) {
      if (error.response) {
        // 服务器返回了错误状态码
        console.error('API错误:', error.response.data);
      } else if (error.request) {
        // 请求已发出，但没有收到响应
        console.error('网络错误:', error.request);
      } else {
        // 请求配置有误
        console.error('请求错误:', error.message);
      }
    }
    return Promise.reject(error);
  }
);

// 覆盖axios的类型定义，使其返回类型为直接的响应数据
declare module 'axios' {
  export interface AxiosInstance {
    get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
    post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
    put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
    delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
    patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  }
}

export default api;